import reportsApiCreator from './reportsApiCreator';

const GRAPHS_API_CACHE_KEY = 'graphsApiCache';

const graphsApi = reportsApiCreator(GRAPHS_API_CACHE_KEY);

export default graphsApi;
